export default "__VITE_ASSET__BNOE8EJJ__"